import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Envelope, ArrowLeft, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e2) {
      setErr(formatApiError(e2, "No se pudo procesar la solicitud"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="w-full max-w-md" data-testid="forgot-password-container">
        <div className="mb-8 text-center">
          <div className="overline text-klein">Recuperar acceso</div>
          <div className="h-display text-5xl font-black tracking-tighter mt-1">
            Vende<span className="text-klein">IA</span>
          </div>
          <p className="text-sm text-muted2 mt-2">
            Te enviaremos instrucciones para restablecer tu contraseña.
          </p>
        </div>

        {sent ? (
          <div
            className="border border-zinc-200 p-8 text-center space-y-3"
            data-testid="forgot-success"
          >
            <CheckCircle size={42} weight="fill" className="text-[#00C853] mx-auto" />
            <div className="h-display text-xl font-bold">Solicitud recibida</div>
            <p className="text-sm text-muted2">
              Si la cuenta existe, recibirás un enlace de restablecimiento. El enlace expira en 30
              minutos.
            </p>
            <p className="text-xs text-muted2 border-t pt-3">
              ¿No te llega? Pídele al administrador que busque el enlace en{" "}
              <span className="font-mono">/auditoria</span> (acción <em>update · auth</em>) y te lo
              comparta.
            </p>
            <Link
              to="/login"
              className="inline-flex items-center gap-1 text-sm text-klein font-medium"
              data-testid="forgot-back-to-login"
            >
              <ArrowLeft size={14} /> Volver al login
            </Link>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="space-y-4 border border-zinc-200 p-8"
            data-testid="forgot-form"
          >
            <div>
              <label className="overline block mb-2">Email de la cuenta</label>
              <div className="flex items-center border border-zinc-300 px-3 focus-within:border-klein">
                <Envelope size={16} className="text-muted2" />
                <input
                  type="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  data-testid="forgot-email-input"
                  className="flex-1 px-3 py-3 text-sm outline-none"
                />
              </div>
            </div>

            {err && (
              <div
                className="text-sm text-red-600 border border-red-200 bg-red-50 px-3 py-2"
                data-testid="forgot-error"
              >
                {err}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="w-full bg-klein text-white py-3 text-sm font-medium hover:bg-klein/90 disabled:opacity-60"
            >
              {loading ? "Enviando…" : "Enviar instrucciones"}
            </button>

            <Link
              to="/login"
              className="inline-flex items-center gap-1 text-xs text-klein hover:underline"
              data-testid="forgot-back-link"
            >
              <ArrowLeft size={12} /> Volver al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
